<template>
    <div class="cd-section" id="features" >
        <div class="page-header page-header-small">
            <parallax class="page-header-image"
                 style="background-image: url('img/monitor-gif.gif')">
            </parallax>
            <div class="content-center">
                <div class="row">
                    <div class="col-md-9 ml-auto mr-auto">
                        <h1 class="title"><img v-lazy="'img/GLOGO512.png'" alt="G" class="g-img"><span style="color:rgba(255,255,255,0) !important;font-family: 'Open Sans',sans-serif;position:absolute;">G</span><span  style="font-family: 'Open Sans',sans-serif;"><em class="d3-text">AMS+</em></span><span style="font-weight:200;font-size:20px;">&trade;</span> Monitoring</h1>
                        <h3><b><em>GAMS+</em></b> is a cutting edge Refrigeration &amp; HVAC <span style="color:rgb(0, 255, 149);">G</span>raphical <span style="color:rgb(0, 255, 149);">A</span>larm <span style="color:rgb(0, 255, 149);">M</span>onitoring <span style="color:rgb(0, 255, 149);">S</span>ystem built by the same people who use it every day.</h3>
                    </div>
                </div>
            </div>
        </div>
        <!--     *********     FEATURES 6      *********      -->
        <div class="features-6" style="">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 ml-auto mr-auto text-center">
                        <h2 class="title">Refrigeration &amp; HVAC Monitoring with Diagnostics Dashboards and Instant Alerts by Phone, Text or Email</h2>

                        <h4 class="description"><span style="font-family: 'Open Sans',sans-serif;font-weight:bold;"><em>GAMS+</em></span> is our cloud-based HVAC-R monitoring, performance and diagnostics tool that securely collects real-time refrigeration &amp; HVAC data from any popular commercial and industrial control system. With smart alarm filtering, get instant alerts via phone call, email or text for the alarms that actually matter.  <span style="font-family: 'Open Sans',sans-serif;font-weight:bold;"><em>GAMS+</em></span> provides precise detail when issues arise allowing you to respond rapidly while reducing costs due to product loss and disruptive onsite service calls. <a href="#contact" @click="gConversion()">Contact us</a> for a demo.</h4>

                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4">
                        <div class="info info-horizontal">
                            <div class="icon icon-info">
                                <i class="now-ui-icons arrows-1_cloud-upload-94"></i>
                            </div>
                            <div class="description">
                                <h4 class="info-title">Anywhere Access</h4>
                                <p>View all of your facilities on one platform from any smartphone, tablet or computer. You can even gain direct access to your controllers through <span style="font-family: 'Open Sans',sans-serif;font-weight:bold;"><em>GAMS+</em></span>, including on your smartphone.</p>
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <div class="icon icon-success">
                                <i class="now-ui-icons business_chart-bar-32"></i>
                            </div>
                            <div class="description">
                                <h4 class="info-title">Improved product safety</h4>
                                <p>Your product’s integrity is our company's business. We ensure that your auditing and regulatory compliance reporting requirements are continuously met through our automated HACCP temperature quality reports (TQR) which exceeds all national and international standards.</p>
                            </div>
                        </div>
                        
                    </div>
                    <div class="col-lg-4" style="position:relative;">
                        <div class="phone-container">
                            <span data-v-27c2f428="" class="helper"></span>
                            <h1 class="center-loading-title d3-text" style="font-family: 'Open Sans';width: 260px;text-align: center;">GAMS+</h1>
                            <img src="img/iphonegams.png" alt="gams plus iphone" style="position:relative;z-index:22;"/>
                            <div class="pie-container">
                                <div class="lds-css ng-scope" id="loading-pie">
                                    <div style="width:100%;height:100%;margin:0 auto;" class="lds-wedges">
                                        <img src="https://gams.rocks/img/GLOGOoverlay.png" style="position: absolute;" class="gover"/>
                                        <div style="width:200px;height:200px;overflow:hidden;">
                                            <div>
                                                <div></div>
                                            </div>
                                            <div>
                                                <div></div>
                                            </div>
                                            <div>
                                                <div></div>
                                            </div>
                                            <div>
                                                <div style="width:100px;"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- End Loading icon -->
                        </div>
                    </div>
                    <div class="col-lg-4">
                        
                        
                        <div class="info info-horizontal">
                            <div class="icon icon-danger">
                                <i class="now-ui-icons ui-1_bell-53"></i>
                                
                            </div>
                            
                            <div class="description">
                                <h5 class="info-title">Instant Alerts</h5>
                                <p>We make it easy... You decide who gets notified for each type of alarm plus how they should be alerted (phone call, email and/or text). If alarms don't get acknowledged within a specified time frame, we automatically escalate the issue by having notifications go to a second or third group of contacts.</p>
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <div class="icon icon-warning">
                                <i class="now-ui-icons business_chart-pie-36 "></i>
                            </div>
                            <div class="description">
                                <h5 class="info-title">Reduce Maintenance Costs</h5>
                                <p>Our next generation refrigeration performance dashboards enables our clients to isolate issues before they become significant problems. With our proprietary maintenance alerts, we notify you of potential issues across all of your refrigeration assets and locations.</p>
                            </div>
                        </div>
                        
                    </div>
                    
                </div>
            </div>
        </div>
        <!--     *********     FEATURES 5      *********      -->
        <div class="features-5 much-darker-background-img section-image" style="background-image: url('img/bgmon2.png')">
            <div class="col-md-8 ml-auto mr-auto text-center">
                <h2 class="title">Facility at Your Fingertips</h2>
                <h4 class="description"><span style="font-family: 'Open Sans',sans-serif;font-weight:bold;"><em>GAMS+</em></span> is customized to meet the specific requirements of each client. As a part of our <span style="font-family: 'Open Sans',sans-serif;font-weight:bold;"><em>GAMS+</em></span> monitoring and support package we typically provide the following:</h4>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 verticle-img visible-md">
                        <div class="tablet-container frame">
                            <span class="helper"></span><img v-lazy="'img/ipadmonitor.png'"  alt="gams plus ipad"/>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="info info-horizontal">
                            <div class="icon icon-primary icon-circle">
                                <i class="now-ui-icons business_globe"></i>
                            </div>
                            <div class="description">
                                <h4 class="info-title">Direct Controller Access</h4>
                                <!-- <p>The moment you use Now UI Kit, you know you’ve never felt anything like it. With a single use lets you do more than ever before. </p> -->
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <div class="icon icon-primary icon-circle">
                                <i class="now-ui-icons ui-1_bell-53"></i>
                            </div>
                            <div class="description">
                                <h4 class="info-title">24x7 Alarm Notifications</h4>
                                <!-- <p>Divide details about your product or agency work into parts. Write a few lines about each one. A paragraph describing a feature.</p> -->
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <div class="icon icon-primary icon-circle">
                                <i class="now-ui-icons design_bullet-list-67"></i>
                            </div>
                            <div class="description">
                                <h4 class="info-title">Temperature Compliance Reports</h4>
                                <!-- <p>Divide details about your product or agency work into parts. Write a few lines about each one. A paragraph describing a feature.</p> -->
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <div class="icon icon-primary icon-circle">
                                <i class="now-ui-icons business_chart-bar-32 "></i>
                            </div>
                            <div class="description">
                                <h4 class="info-title">Real-time &amp; Historical Temperature Logging</h4>
                                <!-- <p>Divide details about your product or agency work into parts. Write a few lines about each one. A paragraph describing a feature.</p> -->
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <div class="icon icon-primary icon-circle">
                                <i class="now-ui-icons location_map-big "></i>
                            </div>
                            <div class="description">
                                <h4 class="info-title">Custom Graphical Site Layouts</h4>
                                <!-- <p>Divide details about your product or agency work into parts. Write a few lines about each one. A paragraph describing a feature.</p> -->
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <div class="icon icon-primary icon-circle">
                                <i class="now-ui-icons gestures_tap-01"></i>
                            </div>
                            <div class="description">
                                <h4 class="info-title">Initiate Setpoint Changes &amp; Manual Defrost</h4>
                                <!-- <p>Divide details about your product or agency work into parts. Write a few lines about each one. A paragraph describing a feature.</p> -->
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <div class="icon icon-primary icon-circle">
                                <i class="now-ui-icons design_bullet-list-67"></i>
                            </div>
                            <div class="description">
                                <h4 class="info-title">Controller Backups</h4>
                                <!-- <p>Divide details about your product or agency work into parts. Write a few lines about each one. A paragraph describing a feature.</p> -->
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <div class="icon icon-primary icon-circle">
                                <i class="now-ui-icons media-2_sound-wave"></i>
                            </div>
                            <div class="description">
                                <h4 class="info-title">Controller Connectivity Alerts</h4>
                                <!-- <p>Divide details about your product or agency work into parts. Write a few lines about each one. A paragraph describing a feature.</p> -->
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <div class="icon icon-primary icon-circle">
                                <i class="now-ui-icons ui-1_bell-53"></i>
                            </div>
                            <div class="description">
                                <h4 class="info-title">Smart Nuisance Alarm Filtering</h4>
                                <!-- <p>Divide details about your product or agency work into parts. Write a few lines about each one. A paragraph describing a feature.</p> -->
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 verticle-img hidden-md">
                        <div class="tablet-container frame">
                            <span class="helper"></span><img v-lazy="'img/ipadmonitor.png'"  alt="gams plus monitoring"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--     *********    END FEATURES 5      *********      -->
        <!--     *********     FEATURES 7      *********      -->
        <div class="features-7">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 mr-auto ml-auto text-center">
                        <h2 class="title">Take Control of Your Data</h2>
                        <h4 class="description"><span style="font-family: 'Open Sans',sans-serif;font-weight:bold;"><em>GAMS+</em></span> works across many different manufactures and device types, gathering all your relevant data in one place. From centralized controllers like Emerson and Danfoss, to stand alone devices using protols like Modbus, <span style="font-family: 'Open Sans',sans-serif;font-weight:bold;"><em>GAMS+</em></span> combines all your data into one place, giving you valuable insights into the bigger picture.</h4>
                    </div>
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-6 px-0">
                                <div class="col-sm-12">
                                    <div class="info info-horizontal">
                                        <div class="icon">
                                            <i class="now-ui-icons design-2_ruler-pencil"></i>
                                        </div>
                                        <div class="description">
                                            <h5 class="info-title">Custom Solutions</h5>
                                            <p class="description"><span style="font-family: 'Open Sans',sans-serif;font-weight:bold;"><em>GAMS+</em></span> is packed full of features, but sometimes you need a solution built just for you. We work with our customers to achieve their own goals with their data. Whether that's exporting data in custom formats, or displaying the data in a way that makes more sense for them, our team can achieve any goal. </p>
                                        </div>
                                    </div>
                                    <div class="info info-horizontal">
                                        <div class="icon">
                                            <i class="now-ui-icons business_badge"></i>
                                        </div>
                                        <div class="description">
                                            <h5 class="info-title">Dedicated Team of Developers</h5>
                                            <p class="description">Our in-house development team is always improving <span style="font-family: 'Open Sans',sans-serif;font-weight:bold;"><em>GAMS+</em></span>. Combined with years of controls experience they know what data is most relevant and how to display it in a way that makes sense. Having an in-house team means we can design and develop for your unique situation.</p>
                                        </div>
                                    </div>
                                    <div class="info info-horizontal">
                                        <div class="icon">
                                            <i class="now-ui-icons users_single-02"></i>
                                        </div>
                                        <div class="description">
                                            <h5 class="info-title">Built for Every Department</h5>
                                            <p class="description">From corporate headquarters to the local maintenance contractor, <span style="font-family: 'Open Sans',sans-serif;font-weight:bold;"><em>GAMS+</em></span> is built with all departments in mind. We know the needs of food safety departments and maintenance departments are not the same. The local refrigeration contractor and corporate alarm handling have different needs. <span style="font-family: 'Open Sans',sans-serif;font-weight:bold;"><em>GAMS+</em></span> is built in an intuitive way to empower each department without overwhelming them with irrelevant information.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="image-container">
                                    <img v-lazy="'img/ipad3.jpg'" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--     *********    END FEATURES 7      *********      -->
        <!--     *********     FEATURES 5      *********      -->
        <!--  -->
        <div class="features-5 section-image darker-background-img" style="background-image: url('img/hvac_backdrop.jpg')">
            <div class="container">
                <div class="row">
                    <div class="col-md-7" style="pointer-events: none;user-select:none;-webkit-user-select:none;">
                        <div class="tablet-container" style="background-image:url('img/ahu.gif');width:100%;height:100%;background-position: center;background-repeat: no-repeat;background-size: contain;min-height: 200px;pointer-events: none;user-select:none;-webkit-user-select:none;">
                        </div>
                    </div>
                    <div class="col-md-5">
                        <h2 class="title"><em><b>GAMS+</b></em> HVAC</h2>
                        <div class="info info-horizontal">
                            <div class="icon icon-primary icon-circle">
                                <i class="now-ui-icons ui-2_settings-90"></i>
                            </div>
                            <div class="description">
                                <h4 class="info-title">Modify Setpoint Targets</h4>
                                <p>Update your AHU/RTU targets right in <span style="font-family: 'Open Sans',sans-serif;font-weight:bold;"><em>GAMS+</em></span> without having to connect to a controller. </p>
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <div class="icon icon-primary icon-circle">
                                <i class="now-ui-icons ui-1_zoom-bold"></i>
                            </div>
                            <div class="description">
                                <h4 class="info-title">Spot Issues at a Glance</h4>
                                <p>Because of how historical data is displayed in <span style="font-family: 'Open Sans',sans-serif;font-weight:bold;"><em>GAMS+</em></span>, issues become obvious without having to navigate through multiple pages of settings and logs.</p>
                            </div>
                        </div>
                        <div class="info info-horizontal">
                            <div class="icon icon-primary icon-circle">
                                <i class="now-ui-icons location_map-big"></i>
                            </div>
                            <div class="description">
                                <h4 class="info-title">Integrated with Refrigeration Layout</h4>
                                <p>View all of your location's refrigeration and HVAC data on a single, easy to understand layout. See how indoor and outdoor temperatures affect your refrigeration efficiency. </p>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <!--     *********    END FEATURES 5      *********      -->
        
        <div class="about-contact">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 mr-auto ml-auto text-center">
                        <h2 class="text-center title">Want a Demo of <span style="font-family: 'Open Sans',sans-serif;font-weight:bold;"><em>GAMS+</em></span>&trade;?</h2>
                        <h4 class="text-center description">Schedule a free guided tour of GAMS Plus with one of our monitoring experts today.</h4>
                            <a href="#contact" @click="gConversion()" class="btn btn-primary btn-lg" >Contact us</a>
                    </div>
                </div>
            </div>
        </div>
        <!--     *********    END FEATURES 6      *********      -->
        
        <!--     *********     BLOGS 3      *********      -->
        <div class="blogs-3" v-if="latest != null && latest.length > 0">
            <div class="container">
                <div class="row">
                    <div class="col-md-10 ml-auto mr-auto">
                        <h2 class="title">Related Articles</h2>
                        <br />
                        <template  v-for="article in latest">
                        <card type="blog" plain :key="article._id">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="card-image">
                                        <img class="img img-raised rounded" v-lazy="article.headerimg" @click="goTo(article._id)"  style="cursor:pointer;"/>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <h3 class="card-title">
                                        <router-link class="" :to="{ path: '/article', query: { id: article._id }}">{{article.title}}</router-link>
                                    </h3>
                                    <p class="card-description">
                                        {{article.readmore}}
                                        <router-link class="" :to="{ path: '/article', query: { id: article._id }}">Read More</router-link>
                                    </p>
                                    <div class="author">
                                        <img v-lazy="article.authorimg" alt="..." class="avatar img-raised">
                                        <span>{{article.author}}</span>
                                    </div>
                                </div>
                            </div>
                        </card>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <!--     *********    END BLOGS 3      *********      -->
        <!--     *********    CONTACT US 1     *********      -->
        <contact></contact>
        
        <!--     *********    END CONTACT US 1      *********      -->
    </div>
</template>
<script>
  import Contact from './components/Contact'
  import { Card } from '@/components';

  export default {
    name: 'presentation',
    bodyClass: 'presentation-page',
    components: {
      Contact,
      Card,
    },
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'GAMS+ Refrigeration Monitoring',
      meta: [
        { vmid: 'description', name: 'description', content: 'Commercial & Industrial HVAC & Refrigeration monitoring, alarm management, diagnostics. GAMS+ is a next generation Graphical Alarm Monitoring System for refrigeration & HVAC systems. Real-time data visualization & instant alerts by phone, text or email.' },
        { vmid: 'keywords', name: 'keywords', content: 'gams plus,refrigeration monitoring, refrigeration alarm management, temperature monitor,remote temperature monitor,freezer temperature log,walk in freezer temperature, danfoss, danfoss monitoring, HVAC, controls monitoring system, food safety, danfoss enterprise, food safety, freezer alarm' }
      ],
      links: [
                {rel: 'canonical', href: 'https://electronictechcorp.com'}
            ]
    },
    data () {
        return {
            latest: null,
            domain: 'https://api.website.gamsplus.systems',
        }
    },
    mounted() {
        this.getLatest()
    },
    methods: {
        getLatest() {
            this.$http.post(this.domain+'/articles/similar/Monitoring',{
                    'title': '',
                },{
                headers: {
                    'content-type' : 'application/json'
                }
            }).then(function(data){
                this.latest = data.body
                
            })
        },
        goTo(articleID) {
            this.$router.push({ path: '/article', query: { id: articleID }})
        },
        gConversion(){
            this.$ga.event('Contact', 'Submit', 'Form', 1)
        }
    },
  }
</script>
<style scoped>

.d3-text {
color: white;
text-shadow: 0 1px 0 #ccc, 0 2px 0 #c9c9c9, 0 3px 0 #bbb, 0 4px 0 #b9b9b9, 0 5px 0 #aaa, 0 6px 1px rgba(0,0,0,.1), 0 0
5px rgba(0,0,0,.1), 0 1px 3px rgba(0,0,0,.3), 0 3px 5px rgba(0,0,0,.2), 0 5px 10px rgba(0,0,0,.25), 0 10px 10px
rgba(0,0,0,.2), 0 20px 20px rgba(0,0,0,.15);
transition: all ease 2s;
}
.d3-text-small {
color: white;
text-shadow: 0 1px 0 #ccc, 0 2px 0 #c9c9c9, 0 3px 0 #bbb, 0 0 5px rgba(0,0,0,.1), 0 1px 3px rgba(0,0,0,.3), 0 3px 5px
rgba(0,0,0,.2), 0 5px 10px rgba(0,0,0,.25), 0 10px 10px rgba(0,0,0,.2);
}
.gover{
    position: absolute;
    z-index: 20;
    width: 253px;
    left: 5px;
    top: 16px;
}
.frame {
    height: 100%;      /* equals max image height */
    width: 100%;
    white-space: nowrap;
    
    text-align: center; margin: 1em 0;
}

.helper {
    display: inline-block;
    height: 100%;
    vertical-align: middle;
}

.verticle-img img {
    vertical-align: middle;
}
.section-image .info-title, .section-image .info.info-horizontal .icon i, .section-image .card-pricing.card-plain ul li {
    color: inherit;
}
.about-contact {
    padding: 80px 0;
}
.features-7:after, .features-2:after, .features-8:after {
    background-color: rgba(0, 0, 0, 0.55);
}
.features-7:after{
    background-color: rgba(0, 0, 0, 0);
}
.features-7 .info .info-title, .features-7 .title {
    color: initial;
}
.features-5 .description, .features-5 .title {
    position: relative;
    z-index: 2;
}
.features-5 .title + .description {
    margin-bottom: 70px;
}
</style>
<style>
.tqr {
    position: absolute;
    overflow: hidden;
    max-width: 100%;
}
.tqr>img{
    max-width: initial;
}
.features-8 .card-image {
    border-bottom: 1px solid #e3e3e3;
}
@keyframes lds-wedges {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@-webkit-keyframes lds-wedges {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
.lds-wedges {
                    position: relative;
                    background-color: #00bbe8;
                  }

                  .lds-wedges>div>div {
                    -webkit-transform-origin: 100px 100px;
                    transform-origin: 100px 100px;
                    -webkit-animation: lds-wedges 5.7s linear infinite;
                    animation: lds-wedges 5.7s linear infinite;
                  }

                  .lds-wedges>div>div>div {
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 200px;
                    height: 100px;
                    -webkit-transform-origin: 100px 100px;
                    transform-origin: 100px 100px;
                  }

                  .lds-wedges>div div:nth-child(1)>div {
                    background: #00BBE8;
                    -webkit-transform: rotate(0deg);
                    transform: rotate(0deg);
                  }

                  .lds-wedges>div div:nth-child(1) {
                    -webkit-animation-duration: 2.45s;
                    animation-duration: 2.45s;
                  }

                  .lds-wedges>div div:nth-child(2)>div {
                    background: #EA3001;
                    -webkit-transform: rotate(0deg);
                    transform: rotate(0deg);
                  }

                  .lds-wedges>div div:nth-child(2) {
                    -webkit-animation-duration: 2.9s;
                    animation-duration: 2.9s;
                  }

                  .lds-wedges>div div:nth-child(3)>div {
                    background: #FBF90E;
                    -webkit-transform: rotate(0deg);
                    transform: rotate(0deg);
                  }

                  .lds-wedges>div div:nth-child(3) {
                    -webkit-animation-duration: 3.85s;
                    animation-duration: 3.85s;
                  }

                  .lds-wedges>div div:nth-child(4)>div {
                    background: #7B11ED;
                    -webkit-transform: rotate(0deg);
                    transform: rotate(0deg);
                  }

                  .lds-wedges>div div:nth-child(4) {
                    -webkit-animation-duration: 6.7s;
                    animation-duration: 6.7s;
                  }

                  .lds-wedges {
                    width: 200px !important;
                    height: 200px !important;
                    -webkit-transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
                    transform: translate(-100px, -100px) scale(1) translate(100px, 100px);
                  }
</style>
<style scoped>
.darker-background-img.section-image:after {
    background-color: rgba(0, 0, 0, 0.75);
}
.much-darker-background-img.section-image:after {
    background-color: rgba(0, 0, 0, 0.85);
}
.g-img{
    width: 98px;
    display:inline-block;
    margin-top:-18px;
    margin-right:-17px;
    filter: drop-shadow(2px 2px 3px rgba(0,0,0,0.5));
}
.center-loading-title {
        position: absolute;
    z-index: 60;
    top: 230px;
    font-size: 55px;
    font-weight: 900;
    font-style: italic;
  }
.presentation-page .info {
    max-width: initial;
}
.lds-css{
    position: absolute;
    top: 300px;
    width:100%;
        left: 0px;
}
@media screen and (max-width: 1200px){
    .lds-css{
        top: 400px;
        width:100%;
        left: 0px;
    }
    .center-loading-title {
        top: 330px;
    }
}
@media screen and (min-width: 992px){
    h1.title{
        font-size:7em;
    }
    .visible-md{
        display:none;
    }
    .phone-container {
        height:100%;
    }
    
}

@media screen and (max-width: 991px){
    .hidden-md{
        display:none;
    }
    
    .features-6 .info:first-child {
        padding-top: 0px;
    }
    .presentation-page .section-basic-components {
        padding: 30px 0 190px 0;
    }
    .lds-css{
        top: 220px;
        width:100%;
        left: 0px;
    }
    .center-loading-title {
        top: 150px;
    }
    h1.title{
        font-size:7em;
    }
}
@media (max-width: 768px){
    h1.title{
        font-size:5em;
    }
    .lds-css{
        top: 220px;
        width:100%;
        left: 0px;
    }
    .g-img{
        width: 70px;
        margin-top:-10px;
        margin-right:-13px;
    }
    .features-7 .image-container {
        height: auto;
    }
}
@media screen and (max-width: 576px){
    h1.title{
        font-size:3.5em;
    }
    
    .lds-css{
        top: 220px;
        width:100%;
        left: 0px;
    }
    .g-img{
        width: 50px;
        margin-top:-5px;
        margin-right:-9px;
    }
}
.features-6 .phone-container {
    margin: 60px auto;
}
</style>